
import { defineComponent } from 'vue';
import { state } from '@/util/job'

export default defineComponent({
  name: 'Pagination',
  setup(){
    const leftArrow = () => {
      state.currentPage == 1 ? '' : state.currentPage-=1
    }
    const rightArrow = () => {
      state.currentPage == state.jobListArray.length ? '' : state.currentPage+=1
    }
    return { state, leftArrow, rightArrow }
  }
});
